export default "__VITE_ASSET__TYVAyt2r__"